<div class="kpi-card" data-testid="kpi-karte" role="group" [attr.aria-labelledby]="labelledBy">
  <div class="kpi-card__head">
    <div class="kpi-card__icon" [style.background]="iconBackground()" [style.color]="iconColor()" aria-hidden="true">
      <mat-icon>{{ icon() }}</mat-icon>
    </div>
  </div>
  <div>
    <div class="kpi-card__label" [attr.id]="labelId">{{ label() }}</div>
    <div class="kpi-card__value" [attr.id]="valueId">
      <span>{{ value() }}</span>
      @if (suffix()) {
        <span class="kpi-card__suffix" [attr.aria-hidden]="suffixAria() ? 'true' : null">{{ suffix() }}</span>
        @if (suffixAria()) {
          <span class="kpi-card__sr">{{ suffixAria() }}</span>
        }
      }
    </div>
  </div>
  @if (hasSparkline()) {
    <div class="kpi-card__sparkline">
      <app-sparkline
        [data]="sparkline()"
        [colorVar]="iconColorVar()"
        [width]="200"
        [height]="36"
        [ariaLabel]="sparklineAria()"
      />
    </div>
  }
</div>
